import { ArrowUpDown, ArrowUp, ArrowDown } from "lucide-react";
import { TableHead } from "@/components/ui/table";

export const STATUS = {
  validated: { label: "Validada", cls: "text-green-700 border-green-200 bg-green-50" },
  pending_review: { label: "Pendiente revisión", cls: "text-amber-700 border-amber-200 bg-amber-50" },
  duplicate: { label: "Duplicada", cls: "text-red-700 border-red-200 bg-red-50" },
  error: { label: "Error OCR", cls: "text-red-700 border-red-200 bg-red-50" },
  processing: { label: "Procesando", cls: "text-blue-700 border-blue-200 bg-blue-50" },
  attached: { label: "Página adjunta", cls: "text-slate-600 border-slate-200 bg-slate-50" },
};

export const PAYMENT = {
  pendiente: { label: "Pendiente", cls: "text-amber-700 border-amber-200 bg-amber-50" },
  parcial: { label: "Pago parcial", cls: "text-blue-700 border-blue-200 bg-blue-50" },
  pagada: { label: "Pagada", cls: "text-green-700 border-green-200 bg-green-50" },
};

export function ConfBadge({ value }) {
  if (value === null || value === undefined) return <span className="text-slate-400">—</span>;
  const cls = value >= 90 ? "text-green-700" : value >= 70 ? "text-amber-700" : "text-red-700";
  return <span className={`font-num text-xs font-semibold ${cls}`}>{value}%</span>;
}

export function InvSortHead({ label, sortKey, defDir = "asc", sort, clickSort, testid, right = false }) {
  const icon = sort.key !== sortKey ? <ArrowUpDown className="w-3.5 h-3.5 text-slate-300" />
    : sort.dir === "asc" ? <ArrowUp className="w-3.5 h-3.5" /> : <ArrowDown className="w-3.5 h-3.5" />;
  return (
    <TableHead className={`cursor-pointer select-none ${right ? "text-right" : ""}`} data-testid={testid}
      onClick={() => clickSort(sortKey, defDir)}>
      <span className={`inline-flex items-center gap-1 ${right ? "justify-end" : ""}`}>{label} {icon}</span>
    </TableHead>
  );
}
